import "./styles.css";
import {StreamCallEvent, StreamVideoClient, StreamVideoEvent, User} from "@stream-io/video-client";
import { cleanupParticipant, renderParticipant } from "./participant";
import { renderControls } from "./controls";
import {
  renderAudioDeviceSelector,
  renderAudioOutputSelector,
  renderVideoDeviceSelector,
  renderVolumeControl,
} from "./device-selector";
import { isMobile } from "./mobile";
import { ClosedCaptionManager } from "./closed-captions";
import globals from "./globals";
let {setApiToken, setDoctorFullName, getDoctorFullName, setDoctorId, getDoctorId, setStreamClient, getStreamClient, getOrCreateModalInstance} = globals;
import {
    getToken,
    ProviderLogin,
    getDoctor,
    logout,
    getSessions,
    updateDoctorStatus,
    savePeerAccessToken
} from './utils';
import { setStartCallHook, endCall, sendTeleconsultMessage, StartConference } from "./consult";

const apiKey = process.env.STREAM_IO_KEY;
//const apiKey = "9s5vanj23w3c";
//const user: User = { id: "Senator_Bail_Organa" };

const startVideoBtn = document.getElementById("start-video-btn");
const startAudioBtn = document.getElementById("start-audio-btn");

const spanAudio = document.getElementById("span-audio");
const iAudio = document.getElementById("i-audio");

const spanVideo = document.getElementById("span-video");
const iVideo = document.getElementById("i-video");

const callBtn = document.getElementById("join-btn");

let g_client;  // Should only instantiate once
let g_user: User = {id: ''} as User;

function sanitizeUserId(s: string) {
    return s.replace(/\./g, "_");
}

const initClient =  (token:string, userId: string, user: User) => {
    console.log("initClient userId =", userId);
    user.id = sanitizeUserId(userId);
    console.log('initClient+', user.id);
    // const token = await getToken(userId);
    let client = StreamVideoClient.getOrCreateInstance({
        apiKey,
        options: {logLevel: "info"},
        user,
        token: token
    });
    console.log(client);

    return client;
}

const startCall = async (checkInId: string, patientId: string, doctorId: string) => {
    console.log("startCall");
    const client: StreamVideoClient = getStreamClient();

// Subscribe to all events
    const unsubscribe = client.on('all', (event: StreamVideoEvent) => {
        switch (event.type) {
            case 'health.check':
                break;

            default:
                console.log('callEvent', event);
        }
    });

    let callId = crypto.randomUUID();
    console.log(`startCall ${patientId}, ${callId}`);
    const call = client.call("default", callId);
    await call.getOrCreate();
    const peerToken = await getToken(patientId);
    let t = await  savePeerAccessToken(checkInId, doctorId, patientId, callId, peerToken.accessToken);
    console.log('startCall t->', JSON.stringify(t));

    startVideoBtn?.addEventListener("click", async () => {
        await call.camera.toggle();
    });

    call.camera.state.status$.subscribe((status) => {
        // @ts-ignore
        //startVideoBtn?.innerText = (status === "enabled") ? "Turn off camera" : "Turn on camera";
        if (status === "enabled") {
            spanVideo.style.color = "green";
            iVideo.classList.remove("fa-video-slash");
            iVideo.classList.add("fa-video");
        } else {
            spanVideo.style.color = "red";
            iVideo.classList.remove("fa-video");
            iVideo.classList.add("fa-video-slash");
        }

    });

    startAudioBtn?.addEventListener("click", async () => {
        await call.microphone.toggle();
    })

    call.microphone.state.status$.subscribe((status) => {
        // @ts-ignore
        // startAudioBtn?.innerText = (status === "enabled") ? "Turn off mic" : "Turn on mic";
        if (status === "enabled") {
            spanAudio.style.color = "green";
            iAudio.classList.remove("fa-microphone-slash");
            iAudio.classList.add("fa-microphone");
        } else {
            spanAudio.style.color = "red";
            iAudio.classList.remove("fa-microphone");
            iAudio.classList.add("fa-microphone-slash");
        }
    });

    callBtn?.addEventListener("click", async () => {
        try {
            await call.leave();
        } catch (e) {
            console.error(e);
        } finally {
            unsubscribe();
            endCall();
        }
    });

    call.join({create: true}).then(() => {
        call.camera.enable();
        call.microphone.enable();
    });

    window.addEventListener("beforeunload", async () => {
        await call.leave();
    });

    const parentContainer = document.getElementById("participants")!;
    call.setViewport(parentContainer);

    call.state.participants$.subscribe((participants) => {
        // render / update existing participants
        participants.forEach((participant) => {
            renderParticipant(call, participant, parentContainer);
        });

        // Remove stale elements for stale participants
        parentContainer
            .querySelectorAll<HTMLMediaElement>("video, audio")
            .forEach((el) => {
                const sessionId = el.dataset.sessionId!;
                const participant = participants.find((p) => p.sessionId === sessionId);
                if (!participant) {
                    cleanupParticipant(sessionId);
                    el.remove();
                }
            });
    });
};

const loginBtn = document.getElementById("login-btn");
const refreshBtn = document.getElementById("refresh-btn");
const username = document.getElementById("Username");
const userpassword = document.getElementById("Password");
const logoutBtn = document.getElementById("logout-btn");

const initLogin = () => {
    const myModal = getOrCreateModalInstance("ModalForm");
    loginBtn.addEventListener('click', () => {
            const u = (<HTMLInputElement>username).value;
            const pw = (<HTMLInputElement>userpassword).value;
            console.log(`login -> ${u} ${pw} `);
            ProviderLogin(u, pw, async () => {
                console.log('myModal', myModal);
                myModal.hide();
                setTimeout(async () => {
                    await getSessions();
                    await getDoctor();

                    let token = await getToken(getDoctorId());

                    setStreamClient(initClient(token.accessToken, getDoctorId(), g_user));
                    setStartCallHook(startCall);
                    // let callId = crypto.randomUUID();
                    // startCall(g_client, callId);
		    console.log('setInterval');
                    setInterval(async () => getSessions(), 3000);
                    await updateDoctorStatus('Available');
                }, 100);

            }, async () => {
                console.log('invalid password');
                $(myModal).find('.modal-dialog').addClass('animate__animated animate__shakeX');
            });
        });
        myModal.show();
};

function ready(fn: any) {
  if (document.readyState !== 'loading') {
    fn();
    return;
  }
  document.addEventListener('DOMContentLoaded', fn);
}
ready(async function(){
    // console.log(`user => ${user.id}`)
    // const token = await getToken(user.id);
    // console.log(`Init -> ${token.accessToken}`)

    let btnSendMessage = document.getElementById("send-message-btn");
    btnSendMessage.addEventListener("click", async () => { sendTeleconsultMessage(); })
    let btnStartTele = document.getElementById("btnStartTele");
    btnStartTele.addEventListener("click", async () => { StartConference(); })

    //init(token.accessToken, user.id, crypto.randomUUID());
    const myModal = getOrCreateModalInstance("ModalForm");
    logoutBtn?.addEventListener('click', async () => {
        console.log('logout');
        logout(async() =>{
                const patientDetails = document.getElementById('patient-details');
                await updateDoctorStatus('-');
                $('#usersonWaitList').empty();
                $(patientDetails).addClass('d-none');
                myModal.show();
                //initLogin();
            },
            async () => {
                myModal.show();
                //initLogin();
            });
    });

    let apiKey = sessionStorage.getItem("api_key");

    initLogin();
    /*
    if (apiKey !== null) {
        initLogin();
        setApiToken(apiKey);
        myModal.hide();
        setTimeout(async () => getDoctor(), 100);
        setInterval(async () => getSessions(), 3000);
        refreshBtn?.addEventListener("click", async () => {
            console.log('refresh');
            await getSessions();
        });
    } else {
        initLogin();
    }
    */
})

